<div class="card dashboardTable">
    <p-table #dt1 [value]="tableData" dataKey="Lot_No" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
        [loading]="loading" [paginator]="true" [globalFilterFields]="['Lot_No', 'TotalApp']" responsiveLayout="scroll">
        <ng-template pTemplate="caption">
            <div class="flex">
                <!-- <p-button label="Clear" [outlined]="true" icon="pi pi-filter-slash" (click)="clear(dt1)" /> -->
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="min-width:10rem">
                    <div class="flex align-items-center">
                        {{ 'LOT_NO' | translate }}
                        <p-columnFilter type="text" field="Lot_No" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th style="min-width:10rem">
                    <div class="flex align-items-center">
                        {{ 'TOTAL_APP' | translate }}
                        <p-columnFilter type="numberic" field="TotalApp" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th style="min-width:10rem">
                    <div class="flex align-items-center">
                        {{ 'ACTION' | translate }}
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-val>
            <tr>
                <td>
                    {{ val?.Lot_No }}
                </td>
                <td>
                    {{ val?.TotalApp }}
                </td>
                <td>
                    <button pButton pRipple pTooltip="view application" icon="pi pi-plus"
                        class="p-button-rounded p-button-accent p-button-primary p-button-sm" (click)="onViewLot(val?.Lot_No)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">No Data found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>


<p-dialog header="" [(visible)]="displayDialog" [modal]="true" [style]="{width: '85%',height:'100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseDialog()">
   
    <div class="dashboardTable">
        <p-table #dt2 [value]="tableData2" dataKey="Lot_No" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
            [loading]="loading" [paginator]="true"  responsiveLayout="scroll"
            [globalFilterFields]="[
            'AppID',
            'CreatedDate',
            'Lot_No',
            'PFMSPaymentDate',
            'Topup',
            'ABY', 
            'CenterShare_Amount',
            'State_share_amt',
            'Subsidy_Amt',
            'Status',
            'Remarks',
            'Fin_Year',
            ]" 
            >
            <ng-template pTemplate="caption">
                <div class="flex">
                    <!-- <p-button label="Clear" [outlined]="true" icon="pi pi-filter-slash" (click)="clear(dt1)" /> -->
                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt2.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'APP_ID' | translate }}
                            <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'CREATED_AT' | translate }}
                            <!-- <p-columnFilter type="date" field="CreatedDate" display="menu"></p-columnFilter> -->
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'LOT_NO' | translate }}
                            <!-- <p-columnFilter type="text" field="Lot_No" display="menu"></p-columnFilter> -->
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'PFMS_PAYMENT_DATE' | translate }}
                            <!-- <p-columnFilter type="text" field="PFMSPaymentDate" display="menu"></p-columnFilter> -->
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'TOP_UP_AMOUNT' | translate }}
                            <!-- <p-columnFilter type="text" field="Topup" display="menu"></p-columnFilter> -->
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'ABY_AMOUNT' | translate }}
                            <!-- <p-columnFilter type="text" field="ABY" display="menu"></p-columnFilter> -->
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'CENTER_SHARE_AMOUNT' | translate }}
                            <!-- <p-columnFilter type="text" field="Centre_share_amt" display="menu"></p-columnFilter> -->
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'STATE_SHARE_AMOUNT' | translate }}
                            <!-- <p-columnFilter type="text" field="State_share_amt" display="menu"></p-columnFilter> -->
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'SUBSIDY_AMOUNT' | translate }}
                            <!-- <p-columnFilter type="text" field="Subsidy_Amt" display="menu"></p-columnFilter> -->
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'STATUS' | translate }}
                            <!-- <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter> -->
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'REMARKS' | translate }}
                            <!-- <p-columnFilter type="text" field="Remarks" display="menu"></p-columnFilter> -->
                        </div>
                    </th>
                    <th style="min-width:5rem">
                        <div class="flex align-items-center">
                            {{ 'FINANCIAL_YEAR' | translate }}
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-val>
                <tr>
                    <td>{{ val?.AppID }}</td>
                    <td>{{ val?.CreatedDate | date:'mediumDate' }}</td>
                    <td>{{ val?.ApplicationType }}</td>
                    <td>{{ val?.Lot_No }}</td>
                    <td>{{ val?.PFMSPaymentDate | date:'mediumDate' }}</td>
                    <td>{{ val?.Topup }}</td>
                    <td>{{ val?.ABY }}</td>
                    <td>{{ val?.Centre_share_amt }}</td>
                    <td>{{ val?.State_share_amt }}</td>
                    <td>{{ val?.Subsidy_Amt }}</td>
                    <td>{{ val?.Status }}</td>
                    <td>{{ val?.Remarks }}</td>
                    <td>{{ val?.Fin_Year }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">No Data found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <div class="flex justify-content-center">
        <button pButton pRipple type="button" label="{{'UPDATE'| translate}}" class="p-button-success m-2" style="float: right;"
            (click)="updateLot()"></button>
    </div>
</p-dialog>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>